import { defineMessages } from "react-intl";

export default defineMessages({
  supportLink: {
    id: "Nsk5WL",
    defaultMessage: "Get support",
    description: "link",
  },
  aboutAppTitle: {
    id: "jDIRQV",
    defaultMessage: "About this app",
    description: "section header",
  },
  appPermissionsTitle: {
    id: "VsGcdP",
    defaultMessage: "App permissions",
    description: "section header",
  },
  appNoPermissions: {
    defaultMessage: "App doesn't have any permissions granted.",
    id: "wDYozn",
  },
  appPermissionsDescription: {
    id: "7oQUMG",
    defaultMessage: "This app has permissions to:",
    description: "apps about permissions",
  },
  dataPrivacyTitle: {
    id: "a55zOn",
    defaultMessage: "Data privacy",
    description: "section header",
  },
  dataPrivacyDescription: {
    id: "CHoZ8S",
    defaultMessage: "View this app’s privacy policy.",
    description: "app privacy policy link",
  },
  noDataPrivacyPage: {
    id: "f3hf+w",
    defaultMessage: "App doesn't provide a privacy policy.",
  },
  noAboutApp: {
    id: "b088Xv",
    defaultMessage: "App doesn't provide a description.",
  },
  editPermissionsButton: {
    defaultMessage: "Edit permissions",
    id: "psmnv9",
  },
});
